"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useQuerySelector = exports.default = void 0;
var _react = require("react");
/**
 * Use a DOM element it's selector and keep it updated even if the DOM changes.
 *
 * @param {string} selector - selector
 * @returns {HTMLElement | null} The element with the specified selector, or null if not found.
 */
const useQuerySelector = selector => {
  const [element, setElement] = (0, _react.useState)(null);
  (0, _react.useEffect)(() => {
    function captureElement() {
      setElement(document.querySelector(selector));
    }
    // Initial capture of the element
    captureElement();
    // Create a MutationObserver to observe changes in the DOM
    const mutationObserver = new MutationObserver(captureElement);
    // Start observing changes in the entire body and its subtree
    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
    // Clean up by disconnecting the observer when unmounting
    return () => mutationObserver.disconnect();
  }, [selector]);
  return element;
};
exports.useQuerySelector = useQuerySelector;
var _default = exports.default = useQuerySelector;